export const ucfirst = (str: string): string => {
	if (!str) return '';
	const [first, ...rest] = [...str];
	return first.toLocaleUpperCase() + rest.join('');
};

export const normalizeInputValue = (value?: string | number | null): string | undefined => {
	if (typeof value === 'number') {
		return value.toString();
	}
	if (value === null) {
		return '';
	}
	if (typeof value === 'string') {
		return value;
	}
	return undefined;
};
